import { Injectable } from '@angular/core';

declare var WifiWizard2: any;

@Injectable()

export class Test300Service {

  testoSSID = 'testo300';
  testoPassword = 'testo300';
  testoEncryption = 'WPA';

  connecting = false;
  connected = false;

  constructor() {}

  public setSSID(ssid){
    this.testoSSID = ssid;
  }

  public setPassword(password){
    this.testoPassword = password;
  }

  public setEncryption(encryption){
    this.testoEncryption = encryption;
  }

  public connect(){
    return new Promise((resolve, reject) => {
      WifiWizard2.getConnectedSSID().then((data) => {
        if(data == this.testoSSID){
          // If already connected to testo, resolve
          resolve();
        } else {
          // If not connected to Testo network, connect to testo
          this.connectTesto().then((result) => {
            resolve(result);
          }).catch(() => {
            // Try again (first connect fails often)
            this.connectTesto().then((result) => {
              resolve(result);
            }).catch((err) => {
              reject(err);
            });
          });
        }
      }).catch((err) => {
        // If not connected to any network, connect to testo
        this.connectTesto().then((result) => {
          resolve(result);
        }).catch((err) => {
          // Try again (first connect fails often)
          this.connectTesto().then((result) => {
            resolve(result);
          }).catch((err) => {
            reject(err);
          });
        });
      });
    })
  }

  private connectTesto(){
    this.connecting = true;
    this.connected = false;
    return new Promise((resolve, reject) => {
      WifiWizard2.connect(this.testoSSID, true, this.testoPassword, this.testoEncryption, false).then((data) => {
        this.connecting = false;
        this.connected = true;
        resolve(data);
      }).catch((err) => {
        this.connecting = false;
        reject(err);
      });
      // Android 10 wifi fix
      this.checkConnected(() => {
        this.connecting = false;
        this.connected = true;
        resolve();
      });
    });
  }

  private checkConnected(callback){
    WifiWizard2.getConnectedSSID().then((data) => {
      if(data == this.testoSSID){
        setTimeout(() => {
          if(this.connecting && !this.connected) {
            this.connecting = false;
            this.connected = true;
            callback();
          }
        }, 5000);
      } else {
        setTimeout(() => {
          if(this.connecting && !this.connected){
            this.checkConnected(callback);
          }
        }, 1000);
      }
    }).catch((err) => {
      setTimeout(() => {
        if(this.connecting && !this.connected){
          this.checkConnected(callback);
        }
      }, 1000);
    });
  }

  public disconnect() {
    this.connected = false;
    return new Promise((resolve, reject) => {
      WifiWizard2.disconnect(this.testoSSID).then(() => {
        resolve();
      }).catch((err) => {
        if(err == 'DISCONNECT_NET_ID_NOT_FOUND'){
          resolve();
        } else {
          reject(err);
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/testo300.service.ts